import { Tag, Typography } from "antd";
import Inspiringcompany from "assets/icons/profilesvgs/Inspiringcompany.svg";
import React, { useContext, useState } from "react";

// import { ProfessionalInterestsDrawer } from '../Edit'
// import { CompanyTitle } from "../Shared";
import { SectionTitle } from "../Shared";

interface PropsType {
  candidate: any;
}

const Styles = {
  root: {
    padding: 15,
    // border: "solid 1px #364972",
    boxShadow: "0px 0px 4px #00000040 ",
    borderRadius: 10,
    paddingBottom: 5,
  },
  body: {
    paddingLeft: 24,
    marginTop: 10,
  },
};

const Inspirecompanies: React.FC<PropsType> = ({ candidate }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const openEdit = () => {
    setOpen(true);
  };

  const Interest = ({ title }: any) => {
    return (
      <Tag
        style={{
          border: "none",
          marginRight: 10,
          marginBottom: 10,
          backgroundColor: "#53946F",
          borderRadius: 20,
          color: "white",
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 10,
          paddingRight: 10,
          fontSize: 14,
          fontWeight: 400,
        }}
      >
        {title}
      </Tag>
    );
  };

  return (
    <>
      {/* <ProfessionalInterestsDrawer candidate={candidate} open={open} handleClose={handleClose} /> */}
      {candidate?.inspiringCompanies.length > 0 && (
        <div style={Styles.root}>
          <SectionTitle
            actionHandler={openEdit}
            title="Inspiring companies"
            icon={Inspiringcompany}
            fontSize="16px"
            actionType="edit"
            showstyle={false}
          />
          <div style={Styles.body}>
            {
              // candidate?.professionalInterests != null &&

              candidate?.inspiringCompanies.map(
                (inspiringCompanie: any, index: any) =>
                  index < 5 && <Interest title={inspiringCompanie.name} />
              )
            }
          </div>
        </div>
      )}
    </>
  );
};

export default Inspirecompanies;
